// 404
//
import React from 'react';
import { Container, Typography, Button, Grid } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

const Page404 = () => {
  return (
    <Container component="main" maxWidth="md" style={{ marginTop: '10%' }}>
      <Grid container spacing={2} direction="column" alignItems="center" justifyContent="center">
        <Typography variant="h1" color="textPrimary">
          404
        </Typography>
        <Typography variant="h4" color="textSecondary">
          Oops! Page not found.
        </Typography>
        <Typography variant="body1" align="center" style={{ marginBottom: '1.5rem' }}>
          The page you are looking for doesn’t exist or has been moved.
        </Typography>
        <Button startIcon={<HomeIcon />} variant="contained" color="primary">
          Go to Home
        </Button>
      </Grid>
    </Container>
  );
};

export default Page404;
